import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { MailX, CheckCircle2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Unsubscribe() {
  const { token } = useParams();
  const [state, setState] = useState("working");

  useEffect(() => {
    axios.post(`${API}/unsubscribe/${token}`)
      .then(() => setState("done"))
      .catch(() => setState("error"));
  }, [token]);

  return (
    <div className="min-h-screen bg-appbg text-white flex items-center justify-center px-4" data-testid="unsubscribe-page">
      <div className="max-w-md w-full border border-neutral-800 bg-appcard p-8 text-center">
        {state === "working" && <div className="heading text-2xl text-neutral-400">ONE MOMENT…</div>}
        {state === "done" && (
          <>
            <CheckCircle2 size={40} className="text-volt mx-auto" />
            <h1 className="heading text-3xl mt-4" data-testid="unsubscribe-confirmed">YOU'RE UNSUBSCRIBED</h1>
            <p className="text-sm text-neutral-400 mt-3 leading-relaxed">
              No more emails from CoachConnect AI. Your pre-built profile stays unclaimed and untouched —
              if you ever change your mind, the claim link in any previous email still works.
            </p>
          </>
        )}
        {state === "error" && (
          <>
            <MailX size={40} className="text-blaze mx-auto" />
            <h1 className="heading text-3xl mt-4">LINK NOT RECOGNIZED</h1>
            <p className="text-sm text-neutral-400 mt-3">This unsubscribe link is invalid or expired. Reply STOP to any of our emails instead.</p>
          </>
        )}
      </div>
    </div>
  );
}
